// Type definition for color schemes
export type ColorScheme = 'light' | 'dark';
export type IconColor = ColorScheme | 'whatsapp' | 'instagram';

// Color configuration for each variant
export const ColorConfig = {
  light: {
    text: 'var(--scheme1-text)',
    background: 'var(--scheme1-background)',
    border: 'var(--scheme1-border-default)',
    borderAccent: 'var(--scheme1-border-accent)',
    shadow: 'var(--scheme1-shadow-default)',
    hoverText: 'var(--scheme1-hover-text)',
    hoverBackground: 'var(--scheme1-hover-background)',
    hoverBorder: 'var(--scheme1-hover-border)',
    ctaText: 'var(--scheme1-cta-text)',
    ctaBackground: 'var(--scheme1-cta-background)',
    ctaBorder: 'var(--scheme1-cta-border)',
    ctaHoverText: 'var(--scheme1-cta-hover-text)',
    ctaHoverBackground: 'var(--scheme1-cta-hover-background)',
    ctaHoverBorder: 'var(--scheme1-cta-hover-border)',
    ctaActiveText: 'var(--scheme1-cta-active-text)',
    ctaActiveBackground: 'var(--scheme1-cta-active-background)',
    ctaActiveBorder: 'var(--scheme1-cta-active-border)',
    ctaShadow: 'var(--scheme1-cta-shadow)',
    ctaHoverShadow: 'var(--scheme1-cta-hover-shadow)',
    activeText: 'var(--scheme1-active-text)',
    activeBackground: 'var(--scheme1-active-background)',
    activeBorder: 'var(--scheme1-active-border)',
    inputBackground: 'var(--scheme1-input-background)',
    inputBorder: 'var(--scheme1-input-border)',
    inputColor: 'var(--scheme1-input-color)',
    inputPlaceholder: 'var(--scheme1-input-placeholder)',
    inputFocusBorder: 'var(--scheme1-input-focus-border)',
    inputFocusShadow: 'var(--scheme1-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme1-input-autofill-background)',
    inputAutofillColor: 'var(--scheme1-input-autofill-color)',
  },
  dark: {
    text: 'var(--scheme2-text)',
    background: 'var(--scheme2-background)',
    border: 'var(--scheme2-border-default)',
    borderAccent: 'var(--scheme2-border-accent)',
    shadow: 'var(--scheme2-shadow-default)',
    hoverText: 'var(--scheme2-hover-text)',
    hoverBackground: 'var(--scheme2-hover-background)',
    hoverBorder: 'var(--scheme2-hover-border)',
    ctaText: 'var(--scheme2-cta-text)',
    ctaBackground: 'var(--scheme2-cta-background)',
    ctaBorder: 'var(--scheme2-cta-border)',
    ctaHoverText: 'var(--scheme2-cta-hover-text)',
    ctaHoverBackground: 'var(--scheme2-cta-hover-background)',
    ctaHoverBorder: 'var(--scheme2-cta-hover-border)',
    ctaActiveText: 'var(--scheme2-cta-active-text)',
    ctaActiveBackground: 'var(--scheme2-cta-active-background)',
    ctaActiveBorder: 'var(--scheme2-cta-active-border)',
    ctaShadow: 'var(--scheme2-cta-shadow)',
    ctaHoverShadow: 'var(--scheme2-cta-hover-shadow)',
    activeText: 'var(--scheme2-active-text)',
    activeBackground: 'var(--scheme2-active-background)',
    activeBorder: 'var(--scheme2-active-border)',
    inputBackground: 'var(--scheme2-input-background)',
    inputBorder: 'var(--scheme2-input-border)',
    inputColor: 'var(--scheme2-input-color)',
    inputPlaceholder: 'var(--scheme2-input-placeholder)',
    inputFocusBorder: 'var(--scheme2-input-focus-border)',
    inputFocusShadow: 'var(--scheme2-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme2-input-autofill-background)',
    inputAutofillColor: 'var(--scheme2-input-autofill-color)',
  },
  whatsapp: {
    text: 'var(--color-whatsapp)',
    hoverText: 'var(--color-whatsapp)',
    activeText: 'var(--color-whatsapp)',
  },
  instagram: {
    text: 'var(--color-instagram)',
    hoverText: 'var(--color-instagram)',
    activeText: 'var(--color-instagram)',
  },
};
